export function parseMaybeJson(value) {
  if (!value) return {};
  if (typeof value === 'object') return value;
  if (typeof value !== 'string') return {};

  try {
    return JSON.parse(value);
  } catch {
    return {};
  }
}

export function getRadarSource(items = []) {
  const radarKeywords = /(radar|scanner|detector|sonar)/i;
  const radarItems = items
    .filter((item) => Number(item?.item_type || -1) === 9 || radarKeywords.test(String(item?.name || '')))
    .sort((a, b) => Number(b.power || 0) - Number(a.power || 0));

  const equippedRadar = radarItems.find((item) => Number(item?.equipped || 0) === 1);
  if (equippedRadar) return equippedRadar;

  return radarItems[0] || null;
}

export function getRadarCapabilities(radarSource) {
  const metadata = parseMaybeJson(radarSource?.metadata || radarSource?.item_metadata);
  const scanMode = String(metadata.scan_mode || metadata.mode || '').toLowerCase();

  const surfaceDetection = metadata.surface_detection !== false
    && !['buried'].includes(scanMode);
  const buriedDetection = metadata.buried_detection === true
    || ['buried', 'mixed', 'all'].includes(scanMode);
  const enemyDetection = metadata.enemy_detection !== false;

  return {
    scanMode: scanMode || 'surface',
    surfaceDetection,
    buriedDetection,
    enemyDetection,
    metadata
  };
}

export function isEntityBuried(entity) {
  const metadata = parseMaybeJson(entity?.metadata || entity?.item_metadata);
  return Boolean(entity?.is_buried || metadata?.buried);
}

export function getRadarRange(power) {
  const radarPower = Number(power || 0);
  return radarPower > 0 ? Math.max(2, Math.min(12, Math.round(radarPower / 20))) : 0;
}
